let typeDefenseObject = {
  'normal': 1,
  'fire': 1,
  'water': 1,
  'electric': 1,
  'grass': 1,
  'ice': 1,
  'fighting': 1,
  'poison': 1,
  'ground': 1,
  'flying': 1,
  'psychic': 1,
  'bug': 1,
  'rock': 1,
  'ghost': 1,
  'dragon': 1,
  'dark': 1,
  'steel': 1,
  'fairy': 1
}

export default typeDefenseObject;